import { useMemo, useState, useEffect } from "react";

import { calculateTimeLeft } from "../../../app/utils";
import { Box, Button, Dialog, DialogContent, Grid, Typography } from "@material-ui/core";
import { useStyles } from "../checkoutPage.styles";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

export const TimerSelectDate = ({ date, onClick }: { date: Date; onClick: () => void }) => {
  const classes = useStyles();
  const initialTimeLeft = useMemo(() => calculateTimeLeft(date), [date]);
  const { isMoreThanSm } = useBreakpoint();

  const [timeLeft, setTimeLeft] = useState(initialTimeLeft);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentTimeLeft = calculateTimeLeft(date);
      if (currentTimeLeft === null) {
        clearInterval(interval);
      }
      setTimeLeft(currentTimeLeft);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [date]);

  return (
    <Dialog
      open={(timeLeft?.minutes === 0 && timeLeft.seconds === 0) || !timeLeft}
      onClose={onClick}
      aria-labelledby="form-dialog-title"
      maxWidth="sm"
    >
      <DialogContent>
        <Box p={isMoreThanSm ? 4 : 2}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Box textAlign="center">
                <Typography variant="h2" paragraph className={classes.timerTitle}>
                  We're sorry but your session has expired
                </Typography>

                <Typography variant="body2" paragraph className={classes.timerContent}>
                  In order to ensure that dates are available to as many customers as possible, we have put a timer on
                  the booking period. If you do not pay your deposit during this period, the date is open to other
                  customers. However, you can still choose this date, if it is still available.
                </Typography>
              </Box>
              <Box mx="auto" width="80%" display="flex" justifyContent="center">
                <Button onClick={onClick} variant="contained" color="primary" fullWidth className={classes.timerButton}>
                  Search Available Dates
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
